















































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'RecordsView',

  data: () => ({
    tableData: [],
    listName: [],
    listSurname: [],
    listCountries: [],
    listDocuments: [],
    filter: {
      name: '',
      surname: '',
      documentCountry: '',
    },
    headers: [
      { text: 'Jméno', value: 'name', width: '15%' },
      { text: 'Příjmení', value: 'surname', width: '15%' },
      { text: 'Země', value: 'documentCountry', width: '10%' },
      { text: 'Typ', value: 'documentType', width: '5%' },
      { text: 'Číslo dokumentu', value: 'documentNumber', width: '15%' },
      { text: 'Jméno školení', value: 'trainingName', width: '15%' },
      { text: 'Absolvován', value: 'trainingFinished', width: '15%' },
      { text: 'Konec platnosti', value: 'trainingExpiration', width: '10%' },
      { text: '', sortable: false, width: '1%' },
    ],
  }),
  mounted() {
    this.listboxDocumentsLoad().then(() => {
      this.dataLoad().then(() => {
        this.listboxLoad('name');
        this.listboxLoad('surname');
        this.listboxCountriesLoad();
      });
    });
  },
  methods: {
    getReport(recordID: number) {
      const printWin = window.open(
        `/api/v1/records/protocol/${recordID}`,
        'ianus-print-window',
        'location=no,titlebar=no,toolbar=no,status=no,menubar=no,width=1024,height=900',
      );
      if (printWin === null) {
        alert('Chyba: Pro tisk je nutno povolit otevírání vyskakovacích oken (popup window)');
        return;
      }
      printWin.addEventListener(
        'load',
        () => {
          printWin.focus();
          // printWin!.print();
        },
        false,
      );
    },
    dataLoad() {
      return new Promise((resolve) => {
        this.checkBlur().then(() => {
          axios
            .get(`/api/v1/records`, {
              params: {
                name: this.filter.name,
                surname: this.filter.surname,
                documentCountry: this.filter.documentCountry,
              },
            })
            .then((response) => {
              this.tableData = response.data;
              let rowDT: { documentType: string };
              for (rowDT of this.tableData) {
                // Priradi nazov dokladu podla kodu
                let rowDL: { code: string; name: string };
                for (rowDL of this.listDocuments) {
                  if (rowDT.documentType === rowDL.code) {
                    rowDT.documentType = rowDL.name;
                    continue;
                  }
                }
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
          resolve();
        });
      });
    },
    listboxLoad(column: string) {
      axios
        .get(`/api/v1/listbox/records/${column}`)
        .then((response) => {
          switch (column) {
            case 'name':
              this.listName = response.data;
              break;
            case 'surname':
              this.listSurname = response.data;
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listboxCountriesLoad() {
      axios
        .get('/api/v1/country')
        .then((response) => {
          this.listCountries = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listboxDocumentsLoad() {
      return new Promise((resolve) => {
        axios
          .get('/api/v1/document')
          .then((response) => {
            this.listDocuments = response.data;
            resolve();
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
          });
      });
    },
    checkBlur() {
      return new Promise((resolve) => {
        (this.$refs.comboName as HTMLElement).blur();
        (this.$refs.comboSurname as HTMLElement).blur();
        resolve();
      });
    },
  },
});
